import { profileClient } from "./clients";
import { ListUsersResponse } from "../shared/interfaces/ListUsersResponse";

export const getOfficers = async (stationId: string): Promise<ListUsersResponse> => {
  const response = await profileClient.get<ListUsersResponse>(`/v1/stations/${stationId}/users`);
  return response.data;
};
